import { authApi, IAuthApi } from '~/categories/admin/apis/adminApiClient/authApi';
import {
  businessFactCheckApi,
  IBusinessFactCheckApi,
} from '~/categories/admin/apis/adminApiClient/businessFactCheckApi';
import { IProposalApi, proposalApi } from '~/categories/admin/apis/adminApiClient/proposalApi';
import { userApi, IUserApi } from '~/categories/admin/apis/adminApiClient/userApi';

export interface IAdminApiClient extends IUserApi, IProposalApi, IAuthApi, IBusinessFactCheckApi {}

export const adminApiClient: IAdminApiClient = {
  ...userApi,
  ...proposalApi,
  ...authApi,
  ...businessFactCheckApi,
};
